import { formatDate } from './formatDate';

export const getInsightStatus = ({
  isArchived,
  isCreatedDate,
  createdAt,
  updatedAt,
}: {
  isArchived: boolean;
  isCreatedDate: boolean;
  createdAt: string;
  updatedAt: string;
}) => {
  return isArchived
    ? `Архивировано ${formatDate(updatedAt)}`
    : isCreatedDate
      ? `Создано ${formatDate(createdAt)}`
      : `Изменено ${formatDate(updatedAt)}`;
};
